/**
 * Das Dial-Gate · RegalPicker vor jedem Anruf.
 *
 * Vorgeschaltet vor `store.startCall(...)` für alle vier Wähl-Wege (Klassik, CallCockpit,
 * Stapelkarte, Telefon-Tabelle) — sie laufen alle über `useTrackedDial`, das jetzt
 * `openDialGate` statt `startCall` direkt ruft. Der Anruf startet erst, wenn dieses Fenster
 * schließt (Übernehmen ODER „Ohne Wechsel anrufen"/X — siehe RegalPicker `callGate`-Prop).
 * Punkt 52, Skript-Abnahme 2026-08-21.
 */
import { useStore } from '../../store';
import RegalPicker from './RegalPicker';

export default function DialGate() {
  const pendingDial = useStore((s) => s.pendingDial);
  const resolveDialGate = useStore((s) => s.resolveDialGate);
  const user = useStore((s) => s.user);

  if (!pendingDial) return null;

  const niche = (pendingDial.lead.niche || '').trim().toLowerCase() || '_global';
  const language = user?.lang || 'de';

  return (
    <RegalPicker
      niche={niche}
      language={language}
      callGate
      onAdopted={() => { /* Anruf startet über onClose, das adopt() selbst danach aufruft */ }}
      onClose={() => resolveDialGate()}
    />
  );
}
